/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import GenericModal from "../../components/GenericModal";
import ResponsiveTable from "../../components/ResponsiveTable";
import moment from "moment";
import { Bar } from "ant-design-pro/lib/Charts";


class VirtualShopTrace extends Component {

    constructor(props: Props) {
        super(props);

        this.state = {

        }

        this.id = "VIRTUAL_SHOP_TRACE";

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

        this.api = {
            get: "get_virtual_shop_trace",
        }
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.refreshData()
    }

    refreshData = () => {
        this.props.dataActions.genericDataGetRequested(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.get)
    }

    render() {
        return (<GenericModal {...this.props}
            title={this.getText(21021)}
            width={1000}
            actionButtons={[{ buttonType: 'refresh', buttonFunction: this.refreshData }]}>
            {this.props.visible == "table" ?
                <ResponsiveTable
                    tableOnly
                    idTable={this.props.data[this.id]}
                    pagination={{ pageSize: 10 }}
                    columns={[
                        { title: this.getText(21022), key: "tDate", dataIndex: "tDate", width: "30%", render: t => t ? moment(t).format("DD/MM/YYYY") : "" },
                        { title: this.getText(21023), key: "tDifference", dataIndex: "tDifference", width: "30%", render: (t, r) => r.index ? t : this.props.curNum - r.tCounter },
                        { title: this.getText(21024), key: "tCounter", dataIndex: "tCounter", width: "40%", render: t => t },
                    ]}
                />
                :
                <Bar height={500} data={this.props.data[this.id].data.map((x, i) => {
                    let y = x.split("\f")
                    return { x: y[1], y: i ? y[2] : this.props.curNum - y[3] }
                })} />}
        </GenericModal>)
    }
}

export default VirtualShopTrace;